import * as React from 'react';
import { DeluxeContext } from './';
import { Link } from 'react-router-dom';
import { ClickElement } from '../form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DeluxeActionButton = ({ dumpert, back, exit }) => {
  return (
    <DeluxeContext.Consumer>
      {({ currentSelection, onClickHandlers }) => {
        const { page } = currentSelection;
        const { dumpertButtonHandler, backButtonHandler, exitButtonHandler } = onClickHandlers;  
        const dumpertButton = dumpert && page === 'features';
        const backButton = back && ['payment', 'feature', 'terms'].includes(page);
        const exitButton = exit && ['payment', 'feature'].includes(page);
        return (
          <>
            {dumpertButton && (
              <ClickElement
                secondary
                ElementType={Link}
                to="/"
                type="button"
                testId="dumpertButton"
                text={
                  <>
                    <FontAwesomeIcon icon='long-arrow-alt-left' className='icon' />
                    <span>Dumpert</span>
                  </>
                }
                onClick={() => dumpertButtonHandler() }
              />
            )}
            {backButton && (
              <ClickElement
                primary
                ElementType="button"
                type="button"
                testId="backButton"
                text={
                  <>
                    <FontAwesomeIcon icon='long-arrow-alt-left' className='icon' />
                    <span>Vorige pagina</span>
                  </>
                }
                onClick={() => backButtonHandler() }
              />
            )}
            {exitButton  && (
              <ClickElement
                primary
                ElementType="button"
                type="button"
                testId="exitButton"
                text={
                  <>
                    <FontAwesomeIcon icon='times' className='icon' />
                    <span>Sluiten</span>
                  </>
                }
                onClick={() => exitButtonHandler() }                
              />
            )}
          </>
        );
      }}
    </DeluxeContext.Consumer>
  );
};